import moment from 'moment-timezone';
import { parseAppointmentDate } from '../../utils/appointmentDate';
import { useState, useEffect } from 'react';
import PatientDoctorDocumentsTable from './PatientDoctorDocumentsTable';
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import PrescripcionDocumentsTable from './PrescripcionDocumentsTable';

const DocumentsInAppointments = ({ patientId, doctorId, onHandleClickDownload, onHandleClickView }) => {
    const [appointments, setAppointments] = useState([]);
    const [selectedAppointments, setSelectedAppointments] = useState([]);
    const [documentsByAppointment, setDocumentsByAppointment] = useState({});
    const [cargando, setCargando] = useState(true);

    //Si me llega el patientId, entonces busco las citas del paciente, si no, busco las citas del doctor
    const petitionAxios = patientId ? `/api/clinic/getAppointments/${patientId}`
        : `/api/clinic/getAppointmentsDoctor/${doctorId}`;

    useEffect(() => {
        apiClient.get(petitionAxios)
            .then((res) => {
                setAppointments(res.data);
                setCargando(false);
            }).catch((error) => {
                alertaGeneral({
                    titulo: 'Error',
                    messageHtml: 'No se pudieron obtener las citas del paciente',
                    isError: true
                });
                setCargando(false);
            })
    }, [patientId, doctorId])

    const onHandleClickVer = (appointmentId) => {
        setSelectedAppointments((prevSelected) => {
            if (prevSelected.includes(appointmentId)) {
                return prevSelected.filter(id => id !== appointmentId);
            } else {
                return [...prevSelected, appointmentId];
            }
        });

        if (!documentsByAppointment[appointmentId]) {
            apiClient.get(`/api/doctor/getDocumentsAppointment/${appointmentId}`)
                .then((res) => {
                    setDocumentsByAppointment((prevDocuments) => ({
                        ...prevDocuments,
                        [appointmentId]: res.data || {}
                    }));
                }).catch((error) => {
                    alertaGeneral({
                        titulo: 'Error',
                        messageHtml: 'No se pudieron obtener los documentos del paciente',
                        isError: true
                    })
                });
        }
    };

    if (cargando) {
        return (
            <div className="flex justify-center items-center h-40">
                <p className="text-sm text-[#70706eff]">Cargando...</p>
            </div>
        )
    }

    return (
        <div className="max-h-[calc(2*220px)] overflow-y-auto bg-white">
            <ul className="divide-y divide-gray-300">
                {appointments && appointments.map((appointment, index) => (
                    <div key={index}>
                        <li key={appointment._id} className="px-4 py-4 sm:px-3">
                            <div className="flex items-center justify-between">
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm md:text-lg font-semibold text-[#70706eff] whitespace-wrap">
                                        {appointment.doctor?.fullName || (appointment.patient?.firstName + ' ' + appointment.patient?.firstLastName)}
                                    </p>
                                    <p className="text-sm text-gray-500 whitespace-wrap">
                                        {appointment.notes || 'Sin notas'}
                                    </p>
                                    <p className="text-sm text-gray-500 whitepace-wrap">
                                        {parseAppointmentDate(appointment.date).format('DD/MM/YYYY')}
                                    </p>
                                </div>
                                <div className="ml-2 whitespace-wrap">
                                    <button
                                        onClick={() => onHandleClickVer(appointment._id)}
                                        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded break-words whitespace-wrap"
                                    >
                                        {selectedAppointments.includes(appointment._id) ? 'Ocultar' : 'Ver'}
                                    </button>
                                </div>
                            </div>
                            {/* Aquí aseguramos que los documentos no se superpongan */}
                        </li>
                        <div className="mt-4"> {/* Añadimos margen superior */}
                            {selectedAppointments.includes(appointment._id) && (
                                // <div className="overflow-auto max-h-40"> {/* Control de overflow para limitar el tamaño */}
                                <PrescripcionDocumentsTable
                                    documentsInAppointment={true}
                                    isDownload={true}
                                    documentos={documentsByAppointment && documentsByAppointment[appointment._id]}
                                    onHandleClickDownload={onHandleClickDownload}
                                    onHandleClickView={onHandleClickView}
                                />
                                // </div>
                            )}
                        </div>
                    </div>
                ))}
            </ul>
            {appointments.length === 0 && !cargando && (
                <div className="border-l border-b border-r border-gray-300 px-4 py-4 sm:px-3">
                    <div className="flex items-center justify-center">
                        <p className="text-sm text-center font-medium text-[#70706eff] whitespace-wrap">
                            No hay citas registradas
                        </p>
                    </div>
                </div>
            )}
        </div>
    )
};


export default DocumentsInAppointments;